import {
  faBars,
  faCircleCheck,
  faLock,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectConfigurationParameterById } from '!core/redux';
import { TrlNoAuthMenuItem } from '»components/atoms';
import { onboardingSlice } from '»components/Auth';
import { legalStatusListSelector } from '»components/Auth/Onboarding/redux/onboarding.selectors';
import {
  isAureaActiveClient,
  isStinvestActiveClient,
} from '»utils/clientsUtils';
import { useAppBarContext, usePageNavigation } from '»utils/customHooks';

import { MenuIconStyled, MenuStyled } from './TrlNoAuthMenu.styles';

export const TrlNoAuthMenu = () => {
  const dispatch = useDispatch();

  const [isBarOpen, setIsBarOpen] = useState(false);
  const [subMenuAnchor, setSubMenuAnchor] = useState(null);

  const hasOnboarding =
    useSelector((state) =>
      selectConfigurationParameterById(state, 'ONBOARDING'),
    )?.value === 'Y';
  const legalStatusList = useSelector(legalStatusListSelector);

  const { navigateToPage } = usePageNavigation();
  const { barHeight } = useAppBarContext();

  const NEW_ACCOUNT_EXP = isAureaActiveClient
    ? 'TRLT_UI-OPEN_ACCOUNT'
    : 'TRLT_UI-CREATE_ACCOUNT';

  const LOGIN_EXP = isAureaActiveClient
    ? 'TRLT_UI-ACCESS_ACCOUNT'
    : 'TRLT_UI-LOGIN';

  const isSubMenuOpen = Boolean(subMenuAnchor);

  const handleCloseMenu = () => {
    setIsBarOpen(false);
  };

  const handleOpenSubMenu = (event) => {
    setSubMenuAnchor(event.currentTarget);
  };

  const handleCloseSubMenu = () => {
    setSubMenuAnchor(null);
  };

  const handleMenuItemClick = ({ route, menuItem }) => {
    handleCloseMenu();
    navigateToPage({ route, menuItem });
  };

  return (
    <>
      <MenuIconStyled
        icon={isBarOpen ? faXmark : faBars}
        onClick={() => {
          setIsBarOpen((barState) => !barState);
          if (hasOnboarding && isStinvestActiveClient) handleCloseSubMenu();
        }}
      />
      <MenuStyled
        open={isBarOpen}
        onClose={handleCloseMenu}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: barHeight + 1,
          left: window.innerWidth / 2,
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <TrlNoAuthMenuItem
          icon={faLock}
          label={LOGIN_EXP}
          handleOnClick={() => {
            handleMenuItemClick({ route: '/Login', menuItem: 'LOGIN' });
          }}
        />
        {hasOnboarding && (
          <>
            <TrlNoAuthMenuItem
              icon={faCircleCheck}
              label={NEW_ACCOUNT_EXP}
              handleOnClick={(event) => {
                if (isStinvestActiveClient) {
                  handleOpenSubMenu(event);
                } else {
                  handleMenuItemClick({
                    route: '/Onboarding',
                    menuItem: 'ONBOARDING',
                  });
                }
              }}
              hasSubMenuArrow={isStinvestActiveClient}
              isSubMenuOpen={isSubMenuOpen}
            />
            {isStinvestActiveClient && (
              <MenuStyled
                open={isSubMenuOpen}
                anchorEl={subMenuAnchor}
                onClose={handleCloseSubMenu}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                isSubMenu
              >
                {legalStatusList.map((legalStatus) => (
                  <TrlNoAuthMenuItem
                    key={legalStatus.classifierValue}
                    label={legalStatus.description}
                    handleOnClick={() => {
                      handleCloseSubMenu();
                      handleMenuItemClick({
                        route: '/Onboarding',
                        menuItem: 'ONBOARDING',
                      });
                      dispatch(
                        onboardingSlice.actions.setLegalStatus({
                          legalStatus: legalStatus.classifierValue,
                        }),
                      );
                    }}
                  />
                ))}
              </MenuStyled>
            )}
          </>
        )}
      </MenuStyled>
    </>
  );
};
